import styled from "styled-components";
import { TableRowEntry } from "@/components/generic/NewTable";
import { ACTIVE_PRIMARY, ACTIVE_HOVER_PRIMARY } from "@/constants/colors";

export const AgencyRowEntry = styled(TableRowEntry)`
  display: ${({ expanded }) => (expanded ? "table-cell" : "inline-flex")};
  max-width: ${({ maxWidth }) => maxWidth}px;
`;

export const ActionText = styled.span`
  color: ${ACTIVE_PRIMARY};
  font-weight: 600;
  text-decoration: underline;
  cursor: pointer;
  margin: ${({ margin }) => margin};

  &:hover {
    color: ${ACTIVE_HOVER_PRIMARY};
  }
`;

export const CollapsibleText = styled.div`
  text-overflow: ellipsis;
  ${({ expanded, maxWidth }) =>
    expanded
      ? `
      max-width: ${maxWidth - 48}px;
      white-space: normal;
      overflow: visible;  
      `
      : `
      max-width: ${maxWidth}px;
      white-space: hidden;
      overflow: hidden;  
  `}
`;
